/*--- template/page.store-locator 

  document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.getElementById('store-search');

    searchInput.addEventListener('input', function() {
      var searchText = searchInput.value.trim().toLowerCase();

      var parentBlocks = document.querySelectorAll('.map-head, .map-head-2');

      parentBlocks.forEach(function(parentBlock) {
        var title = parentBlock.querySelector('.left-title, .left-title-2');
        var content = parentBlock.querySelector('.left-content, .left-content-2');

        var titleText = title ? title.textContent.toLowerCase() : '';
        var contentText = content ? content.textContent.toLowerCase() : '';

        if (titleText.includes(searchText) || contentText.includes(searchText)) {
          parentBlock.style.display = 'block';
        } else {
          parentBlock.style.display = 'none';
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    const leftBlocks = document.querySelectorAll('.map-head, .map-head-2');
    const rightBlocks = document.querySelectorAll('.map-rig, .map-rig-2');

    function setDisplayBasedOnScreenWidth() {
      const isMobile = window.innerWidth <= 767;

      rightBlocks.forEach(rightBlock => {
        rightBlock.style.display = 'none';
      });

      if (rightBlocks.length > 0) {
        rightBlocks[0].style.display = isMobile ? 'block' : 'flex';
      }

      leftBlocks.forEach(leftBlock => {
        leftBlock.addEventListener('click', function() {
          const blockId = this.getAttribute('id');

          rightBlocks.forEach(rightBlock => {
            rightBlock.style.display = 'none';
          });

          const matchingRightBlock = document.querySelector(`.map-rig[id="${blockId}"], .map-rig-2[id="${blockId}"]`);
          if (matchingRightBlock) {
            matchingRightBlock.style.display = isMobile ? 'block' : 'flex';

            if (isMobile) {
              matchingRightBlock.scrollIntoView({ behavior: 'smooth' });
            }
          }
        });
      });
    }

    setDisplayBasedOnScreenWidth();

    window.addEventListener('resize', setDisplayBasedOnScreenWidth);
  });---*/

/*--- section/right-store-2 

  document.addEventListener('DOMContentLoaded', function() {
    // Get all show-gallery buttons
    const showGalleryBtns = document.querySelectorAll('.show-gallery-btn-2');
    const popupOverlay = document.querySelector('.popup-overlay-2');
    const closePopupBtn = document.querySelector('.close-popup-btn-2');
    const mainImg = document.querySelector('.main-img-2');
    const thumbnailContainer = document.querySelector('.thumbnail-container-2');
    let currentIndex = 0;

    showGalleryBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const imageGrid = this.closest('.map-rig-2').querySelectorAll('.popup-img-all-2');
        thumbnailContainer.innerHTML = '';

        imageGrid.forEach((img, index) => {
          const thumbnail = img.cloneNode();
          thumbnail.style.display = 'inline'; // Make sure thumbnails are visible in popup
          thumbnail.dataset.index = index;
          thumbnailContainer.appendChild(thumbnail);
          if (index === 0) {
            mainImg.src = img.src;
            currentIndex = 0;
          }
        });

        popupOverlay.style.display = 'flex';
      });
    });

    thumbnailContainer.addEventListener('click', function(e) {
      if (e.target.tagName === 'IMG') {
        mainImg.src = e.target.src;
        currentIndex = parseInt(e.target.dataset.index);
      }
    });

    closePopupBtn.addEventListener('click', function() {
      popupOverlay.style.display = 'none';
    });

    document.querySelector('.prev-arrow-2').addEventListener('click', function() {
      currentIndex = (currentIndex - 1 + thumbnailContainer.children.length) % thumbnailContainer.children.length;
      mainImg.src = thumbnailContainer.children[currentIndex].src;
    });

    document.querySelector('.next-arrow-2').addEventListener('click', function() {
      currentIndex = (currentIndex + 1) % thumbnailContainer.children.length;
      mainImg.src = thumbnailContainer.children[currentIndex].src;
    });
  });---*/

/*--- right-store.liquid 

  document.addEventListener('DOMContentLoaded', function() {
    // Get all show-gallery buttons
    const showGalleryBtns = document.querySelectorAll('.show-gallery-btn');
    const popupOverlay = document.querySelector('.popup-overlay');
    const closePopupBtn = document.querySelector('.close-popup-btn');
    const mainImg = document.querySelector('.main-img');
    const thumbnailContainer = document.querySelector('.thumbnail-container');
    let currentIndex = 0;

    showGalleryBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const imageGrid = this.closest('.map-rig').querySelectorAll('.popup-img-all');
        thumbnailContainer.innerHTML = '';

        imageGrid.forEach((img, index) => {
          const thumbnail = img.cloneNode();
          thumbnail.style.display = 'inline'; // Make sure thumbnails are visible in popup
          thumbnail.dataset.index = index;
          thumbnailContainer.appendChild(thumbnail);
          if (index === 0) {
            mainImg.src = img.src;
            currentIndex = 0;
          }
        });

        popupOverlay.style.display = 'flex';
      });
    });

    thumbnailContainer.addEventListener('click', function(e) {
      if (e.target.tagName === 'IMG') {
        mainImg.src = e.target.src;
        currentIndex = parseInt(e.target.dataset.index);
      }
    });

    closePopupBtn.addEventListener('click', function() {
      popupOverlay.style.display = 'none';
    });

    document.querySelector('.prev-arrow').addEventListener('click', function() {
      currentIndex = (currentIndex - 1 + thumbnailContainer.children.length) % thumbnailContainer.children.length;
      mainImg.src = thumbnailContainer.children[currentIndex].src;
    });

    document.querySelector('.next-arrow').addEventListener('click', function() {
      currentIndex = (currentIndex + 1) % thumbnailContainer.children.length;
      mainImg.src = thumbnailContainer.children[currentIndex].src;
    });
  });---*/

/*----- ------*/

  document.querySelectorAll('.map-head').forEach(head => {
    head.addEventListener('click', () => {
      document.querySelectorAll('.map-head').forEach(el => el.classList.remove('active'));
      head.classList.add('active');
    });
  });









